import { render, staticRenderFns } from "./ChengjiguanliEdit.vue?vue&type=template&id=3074dcdc&"
import script from "./ChengjiguanliEdit.vue?vue&type=script&lang=js&"
export * from "./ChengjiguanliEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports